
import notice from "@/api/web/home/notice";

export default {
    components: {},
    data() {
      return {
        noticeData:[],
        lang: "",
      };
    },
    watch: {
      
    },
    created() {
        this.getAllNotice();
        this.getLang();
    },
  
    methods: {
          
       // 获取公告栏
       getAllNotice(){
        notice.get().then((res) => {
          this.noticeData=res.data.data?res.data.data:[];
        })
      },

      //跳转到详情页
        JumpToNoticeDetail(row) {
            let {
                href
            } = this.$router.resolve({
                path: "/web/noticeDetail",
                query: {
                    id: row.id,
                },
            });
            window.open(href)
        },

        // 获取当前的语言环境
        getLang() {
            // if (this.$i18n.locale == "zh-CN") {
            // 	this.lang = this.$i18n.locale
            // } else {
            // }
            this.lang = this.$i18n.locale;
        },
    },
  };
  